const PAGE_SIZE = 20;

function normalize(order, source) {
  return { ...order, source, historyKey: `${source}:${order.orderId}`, shopLabel: order.shopLabel || 'Visoria', channelLabel: order.channelLabel || 'Сайт' };
}
export function compareOrders(a, b) {
  const dateDifference = (Date.parse(b.createdAt) || 0) - (Date.parse(a.createdAt) || 0);
  if (dateDifference) return dateDifference;
  if (a.source === 'bot' && b.source === 'bot') return String(a.shop || '').localeCompare(String(b.shop || '')) || (b.billId || 0) - (a.billId || 0) || a.historyKey.localeCompare(b.historyKey);
  return a.historyKey.localeCompare(b.historyKey);
}

/** У каждого источника собственный буфер: невыбранные строки не пропадают между страницами. */
export function createAccountOrdersFeed(api) {
  const sources = [
    { id: 'visoria', page: 0, more: true, queue: [], load: state => api.getAccountOrders(state.page + 1) },
    { id: 'bot', cursor: '', more: true, queue: [], load: state => api.getBotAccountOrders(state.cursor) },
  ];
  const seen = new Set();
  const unpaid = new Map();
  const warnings = new Set();
  let loading = false;
  async function fill() {
    const pending = sources.filter(source => source.more && !source.queue.length);
    const results = await Promise.allSettled(pending.map(source => source.load(source)));
    // Не возвращаем частичные данные после отзыва сессии.
    const unauthorized = results.find(result => result.status === 'rejected' && result.reason?.status === 401);
    if (unauthorized) throw unauthorized.reason;
    results.forEach((result, index) => {
      const source = pending[index];
      if (result.status === 'rejected' || !Array.isArray(result.value?.orders)) {
        source.more = false; warnings.add(source.id); return;
      }
      const data = result.value;
      source.page = (source.page || 0) + 1;
      source.cursor = data.nextCursor || '';
      source.more = Boolean(data.hasMore);
      if (source.id === 'bot' && source.more && !source.cursor) { source.more = false; warnings.add('bot'); }
      (data.unavailableSources || []).forEach(shop => warnings.add(shop));
      [...data.orders, ...(data.unpaid || [])].forEach(raw => {
        const row = normalize(raw, source.id);
        if (row.status === 'unpaid') { unpaid.set(row.historyKey, row); return; }
        if (!seen.has(row.historyKey) && !source.queue.some(item => item.historyKey === row.historyKey)) source.queue.push(row);
      });
      source.queue.sort(compareOrders);
    });
    if (pending.length === 2 && results.every(result => result.status === 'rejected')) throw new Error('История временно недоступна. Попробуйте позже.');
  }
  return {
    async next() {
      if (loading) throw new Error('История уже загружается');
      loading = true;
      try {
        const orders = [];
        let fetches = 0;
        while (orders.length < PAGE_SIZE) {
          if (sources.some(source => source.more && !source.queue.length)) {
            // Ограничиваем одну загрузку, сохраняя позиции для следующей страницы.
            if (++fetches > 20) break;
            await fill();
            // Страница может содержать только неоплаченные заказы; сначала получаем головы всех источников.
            if (sources.some(source => source.more && !source.queue.length)) continue;
          }
          const available = sources.filter(source => source.queue.length);
          if (!available.length) break;
          available.sort((a, b) => compareOrders(a.queue[0], b.queue[0]));
          const row = available[0].queue.shift();
          if (!seen.has(row.historyKey)) { seen.add(row.historyKey); orders.push(row); }
        }
        return {orders, unpaid: [...unpaid.values()].sort(compareOrders), hasMore: sources.some(source => source.more || source.queue.length), unavailableSources: [...warnings]};
      } finally { loading = false; }
    },
  };
}
